export default function(state, payload){
  const {product} = payload;
  state.targetedProduct = product;
  return {...state}
}